/**
 * The single `HotlineClient` instance the dashboard uses for all REST + realtime
 * traffic. Constructed once at module load against the configured backend, with
 * a localStorage-backed token store so a reload keeps the session.
 *
 * `onAuthError` triggers a redirect to /login (wired by the auth provider via a
 * subscriber, so this module stays free of React/router imports).
 */
import { HotlineClient } from '@hotline/client-core';

import { API_BASE_URL } from './config.js';

/** Listeners notified when the session becomes unrecoverable. */
const authErrorListeners = new Set<() => void>();

/** Subscribe to "session lost" events (refresh failed). Returns unsubscribe. */
export function onAuthError(listener: () => void): () => void {
  authErrorListeners.add(listener);
  return () => authErrorListeners.delete(listener);
}

export const client = new HotlineClient({
  baseUrl: API_BASE_URL,
  onAuthError: () => {
    for (const fn of authErrorListeners) fn();
  },
});
